import getTranslatedText from '../../../_flux/helper/get_translated_text';
import Translation from '../../../_flux/components/translation/translation';

export const getShortDayOfTheWeek = (dateObject) => {
    const days = [
        'sun',
        'mon',
        'tue',
        'wed',
        'thu',
        'fri',
        'sat',
    ];

    return getTranslatedText(days[dateObject.getDay()]);
};

export const getDayOfTheWeek = (etaFrom) => {
    const days = [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
    ];

    return getTranslatedText(days[etaFrom.getDay()]);
};

export const getShippingEta = (etaFrom, etaTo) => {
    if (etaFrom === null && etaTo === null) {
        return (<Translation
            translationKey="shipping-time-not-available"
        />);
    }

    let now = new Date();
    let fromHours = Math.floor((etaFrom.getTime() - now.getTime()) / (1000 * 60 * 60));
    let hoursToMidnight = 24 - (now.getHours() + now.getMinutes() / 60);

    let fromDays = Math.floor(fromHours / 24);
    if (fromHours % 24 > hoursToMidnight) {
        fromDays++;
    }

    if (fromDays === 0) {
        return (<Translation
            translationKey="shipping-eta-fast-today"
        />);
    }

    return (<Translation
        translationKey="shipping-eta-fast-date"
        placeholder={{
            'deliveryDate': (
                getDayOfTheWeek(etaFrom)
                + ' '
                + ('0' + etaFrom.getDate()).slice(-2)
                + '/'
                + ('0' + (etaFrom.getMonth() + 1)).slice(-2)
            )
        }}
    />);
};